<template>
  <div class="app-carousel-slide-details">
    <slot name="title-prepend" />

    <Component :is="titleTag" class="title">
      <AppLink v-if="routeTo" :to="routeTo">{{ title }} </AppLink>
      <template v-else>{{ title }} </template>
    </Component>

    <div v-if="description" class="description" v-html="description" />
  </div>
</template>

<script>
import AppLink from '@/components/AppLink.vue';

export default {
  name: 'AppCarouselSlideDetails',
  components: { AppLink },
  props: {
    title: {
      type: String,
      required: true,
    },
    titleTag: {
      type: String,
      default: 'h3',
      validator: (value) => ['h2', 'h3', 'h4', 'h5', 'h6', 'span'].includes(value),
    },
    description: {
      type: String,
      default: null,
    },
    routeTo: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/assets/scss/variables-site/variables' as vars;
@use '@/assets/scss/mixins';

.app-carousel-slide-details {
  display: flex;
  flex-direction: column;
  gap: 6px;

  .title {
    margin-bottom: 0;
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: vars.$c-dark-gray;

    @media (min-width: vars.$tablet-break-point) {
      font-size: 26px;
      font-weight: 700;
      letter-spacing: 4px;
    }

    @media (min-width: vars.$desktop-lg-992-break-point) {
      font-size: 32px;
      letter-spacing: 9px;
    }

    a {
      color: inherit;
      text-decoration: none;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  .description {
    @include mixins.font-with-spacing(16px, 0.18);

    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: vars.$c-gray-86;

    @media (min-width: vars.$tablet-break-point) {
      @include mixins.font-with-spacing(18px, 0.18);
    }

    b,
    strong {
      font-weight: 600;
    }
  }
}
</style>
